import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import { Flex, Input } from '@podiumhq/design-system';

import {
  CARD_ID,
  EXPIRATION_DATE_ID,
  POSTAL_CODE_ID,
  SECURITY_CODE_ID,
} from './constants';
import CreditCardFieldWrapper from './CreditCardFieldWrapper';
import useCreditCardFields from './hooks/useCreditCardFields';

const CreditCardFields = ({
  displayPostalCode,
  fullWidthForm,
  loading,
  trackOnBlurPath,
}) => {
  const { fieldProps = {} } =
    useCreditCardFields(loading, trackOnBlurPath) || {};
  const {
    [CARD_ID]: cardProps = {},
    [EXPIRATION_DATE_ID]: expDateProps = {},
    [SECURITY_CODE_ID]: cvcProps = {},
    [POSTAL_CODE_ID]: zipProps = {},
  } = fieldProps;

  return (
    <>
      <CreditCardFieldWrapper error={cardProps.error} id={cardProps.id}>
        <CardNumberElement {...cardProps} />
      </CreditCardFieldWrapper>

      <Flex direction={!!fullWidthForm ? 'column' : 'row'}>
        <CreditCardFieldWrapper
          boxProps={!!fullWidthForm ? {} : { mr: '16px' }}
          error={expDateProps.error}
          id={expDateProps.id}
        >
          <CardExpiryElement {...expDateProps} />
        </CreditCardFieldWrapper>

        <CreditCardFieldWrapper
          error={cvcProps.error}
          id={cvcProps.id}
          tooltipLabel="The 3- or 4-digit security code usually found on the back of the card."
        >
          <CardCvcElement {...cvcProps} />
        </CreditCardFieldWrapper>

        {displayPostalCode && (
          <CreditCardFieldWrapper
            error={zipProps.error}
            id={zipProps.id}
            tooltipLabel="Enter the ZIP / Postal code of your credit card’s billing address."
          >
            <Input {...zipProps} />
          </CreditCardFieldWrapper>
        )}
      </Flex>
    </>
  );
};

export default CreditCardFields;
